/* eslint-disable jsx-a11y/anchor-is-valid */

import { Link } from 'react-router-dom';

const Burger = ({ className, dataTarget, onClick }) => (
    <a role="button" className={'navbar-burger ' + className}
        onClick={onClick}
        aria-label="menu" aria-expanded="false"
        data-target={dataTarget}>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
    </a>
);

const NavBarItem = ({ path, icon, text }) => (
    <Link className="navbar-item" to={path}>
        <span className="icon-text">
            <span className="icon mr-1">
                <i className={icon}></i>
            </span>
            <span>{text}</span>
        </span>
    </Link>
);

const NavBarDropdown = ({ icon, text, children }) => (
    <div className="navbar-item has-dropdown is-hoverable">
        <a className="navbar-link">
            <span className="icon-text">
                <span className="icon mr-1">
                    <i className={icon}></i>
                </span>
                <span>{text}</span>
            </span>
        </a>

        <div className="navbar-dropdown">
            {children}
        </div>
    </div>
);

export { Burger, NavBarDropdown, NavBarItem };
